<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.cid ? query.cid : query.pid}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}支付计划</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 2">
        <el-breadcrumb-item>行政采购项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=2` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}支付计划</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 3">
        <el-breadcrumb-item>人力资源项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=3` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}支付计划</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/pay' }">支付管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}支付计划</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 预算说明 -->
    <div class="base1">
      <h3 class="ntitle">预算说明</h3>
      <ul>
        <li>
          <p>
            <label>预算：</label><a>{{ form.budget }}</a>
          </p>
          <p>
            <label>服务说明：</label><a style="white-space: pre-wrap;">{{ form.service_info }}</a>
          </p>
          <p style="width: 150%;">
            <label>清单附件：</label>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList" :key="index">
                  <div class="abox">
                    <!-- 选择文件 -->
                    <el-col :span="4" v-if="NodeInclude('46') || NodeInclude('145') || NodeInclude('177')">
                      <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                        :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                        :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                        <el-button size="small" style="width: 80px;">选择文件</el-button>
                      </el-upload>
                    </el-col>
                    <!-- 文件预览及下载 -->
                    <template v-if="item.origin_name">
                      <el-col :span="20">
                        <el-col :span="18">
                          <div class="origin-name">{{ item.origin_name }}</div>
                        </el-col>
                        <el-col :span="2">
                          <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                            target="_blank">查看</el-link>
                        </el-col>
                      </el-col>
                    </template>
                  </div>
                  <el-button class="bbtn" v-if="(index === 0) && (NodeInclude('46') || NodeInclude('145') || NodeInclude('177'))" icon="el-icon-plus"
                    @click="addImage(fileList)" circle></el-button>
                  <el-button class="bbtn" v-if="index > 0 && (NodeInclude('46') || NodeInclude('145') || NodeInclude('177'))" icon="el-icon-minus"
                    @click="removeImage(fileList, index)" circle></el-button>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <p>
            <label>选择支付类别：</label><a>{{ dd.pay_type[form.pay_type] }}</a>
          </p>
          <p>
            <label>服务类目：</label><a>{{ query.kind == 2 || query.kind == 3 ? form.service_type_name : form.service_type_name }}</a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 支付计划 -->
    <div class="form myform" v-if="NodeInclude('94') || NodeInclude('134') || NodeInclude('170')">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">支付计划</div>
        <template v-if="form.pay_type == 1">
          <ul class="anlist">
            <li v-for="(item, index) in form.planList" :key="index">
              <div class="abox">
                <el-form-item label="支付计划名称：" prop="plan_name">
                  <el-col :span="12">
                    {{ item.plan_name }}
                  </el-col>
                </el-form-item>
                <el-form-item label="支付金额：" prop="plan_amount">
                  <el-col :span="12">
                    <el-input @change="v=> numberFn(v, item)" placeholder="请输入" maxlength="100" v-model="item.plan_amount"  clearable
                      :disabled="(item.pay_check_status == '2' || item.pay_check_status == '3') && level != 1" />
                  </el-col>
                </el-form-item>
                <el-form-item label="计划支付时间：" prop="hope_pay_time">
                  <el-col :span="5">
                    <el-date-picker v-model="item.hope_pay_time" type="datetime" value-format="yyyy-MM-dd"
                      :disabled="(item.pay_check_status == '2' || item.pay_check_status == '3') && level != 1" style="width: 100%;">
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </div>
              <el-button class="bbtn" v-if="index === 0" icon="el-icon-plus" @click="addPlan(form.planList)"
                circle></el-button>
              <el-button class="bbtn" v-if="index > 0" icon="el-icon-minus" @click="removePlan(form.planList, index)"
                circle></el-button>
            </li>
            <li>
              <div class="abox">
                <el-form-item label="成本：" prop="">
                  <el-col :span="12">
                    <span>{{ nowCost }}</span>
                  </el-col>
                </el-form-item>
              </div>
            </li>
            <li v-if="form.pay_type == 1">
              <div class="abox">
                <el-form-item label="剩余可用金额：" prop="">
                  <el-col :span="12">
                    <span>{{ remainCost }}</span>
                  </el-col>
                </el-form-item>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          <ul class="anlist">
            <!-- 预支 -->
            <li>
              <div class="abox">
                <el-form-item label="支付计划名称：" prop="plan_name">
                  <el-col :span="12">
                    <span>{{ form.planList1[0].plan_name }}</span>
                  </el-col>
                </el-form-item>
                <el-form-item label="支付金额：" prop="plan_amount">
                  <el-col :span="12">
                    <i class="ico-reddot" style="left: -160px;">*</i>
                    <el-input @input="countCost" placeholder="请输入" maxlength="100" v-model="form.planList1[0].plan_amount"
                      clearable :disabled="(form.planList1[0].pay_check_status == '3') && level != 1" />
                  </el-col>
                </el-form-item>
                <el-form-item label="计划支付时间：" prop="hope_pay_time">
                  <el-col :span="5">
                    <i class="ico-reddot" style="left: -160px;">*</i>
                    <el-date-picker v-model="form.planList1[0].hope_pay_time" type="datetime" value-format="yyyy-MM-dd"
                      :disabled="(form.planList1[0].pay_check_status == '3') && level != 1" style="width: 100%;">
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </div>
            </li>
            <!-- 结算 -->
            <li>
              <div class="abox">
                <el-form-item label="支付计划名称：" prop="plan_name">
                  <el-col :span="12">
                    <span>{{ form.planList1[1].plan_name }}</span>
                  </el-col>
                </el-form-item>
                <el-form-item label="选择退/补：" prop="plan_type">
                  <el-col :span="12">
                    <el-radio-group v-model="form.planList1[1].plan_type" @change="changePlanType"
                      :disabled="(form.planList1[0].pay_status != '3' || form.planList1[1].pay_check_status == '3')  && level != 1">
                      <el-radio label="1">应退</el-radio>
                      <el-radio label="2">应补</el-radio>
                      <el-radio label="3">无需退补</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-form-item>
                <el-form-item label="支付金额：" prop="plan_amount">
                  <el-col :span="12">
                    <el-input @input="countCost" placeholder="请输入" maxlength="100" v-model="form.planList1[1].plan_amount"
                      clearable :disabled="(form.planList1[1].plan_type == '3' || form.planList1[0].pay_status != '3' || form.planList1[1].pay_check_status == '3')  && level != 1" />
                  </el-col>
                </el-form-item>
                <el-form-item label="计划支付时间：" prop="hope_pay_time">
                  <el-col :span="5">
                    <el-date-picker v-model="form.planList1[1].hope_pay_time" type="datetime" value-format="yyyy-MM-dd"
                      :disabled="(form.planList1[0].pay_status != '3' || form.planList1[1].pay_check_status == '3') && level != 1" style="width: 100%;">
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </div>
            </li>
            <li>
              <div class="abox">
                <el-form-item label="成本：" prop="">
                  <el-col :span="12">
                    <span>{{ nowCost }}</span>
                  </el-col>
                </el-form-item>
              </div>
            </li>
            <li v-if="form.pay_type == 1">
              <div class="abox">
                <el-form-item label="剩余可用金额：" prop="">
                  <el-col :span="12">
                    <span>{{ remainCost }}</span>
                  </el-col>
                </el-form-item>
              </div>
            </li>            
          </ul>
        </template>
        <div style="font: 14px/48px arial; margin-bottom: 36px; color: #999;"> 注：支付计划名称系统会自动调整，多笔支付计划请按照实际情况新增 </div>
        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>

      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { timeFormat, thousands,antiThousands } from '@/utils/index.js'
export default {
  name: 'paydetail',
  data() {
    return {
      nodeLimtList: [],
      mType: '',
      level: '',
      pay_type: '',
      remindShow: false,
      planCost: 0,
      nowCost: '0.00',
      remainCost: '0.00',
      projectList: [],//项目列表
      projectArr: {

      },//项目详情
      billList: [],//收款计划
      sonList: [],//子项目
      purchaseList: [],//供应商合同列表
      vendorList: [],//供应商列表
      form: {
        pay_id: '',
        project_id: '',
        son_project_id: '',
        contract_name: '',
        contract_no: '',
        pay_info: '',
        vendor_id: '',
        vendor_type: '',
        budget: '',
        pay_type: '1',
        service_type: '',
        service_info: '',
        contract_id: '',
        check_info: '',
        atta_str: '',
        planList: [
          { plan_name: '', plan_amount: '', hope_pay_time: '', }
        ],
        planList1: [
          { plan_name: '预支', plan_amount: '', hope_pay_time: '', },
          { plan_name: '结算', plan_amount: '0.00', hope_pay_time: '', plan_type: '3' }
        ],
        plan_str: '',
        plan_del: '',        
        projectArr: {//项目详情
          contract_name: '',
        },
        projectSonArr: {//子项目详情
          contract_name: '',
        },
        del_atta_list: [],
      },
      del_plan_list: [],
      rules: {

      },
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.mType = this.query.mType ? this.query.mType : '1'
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    numberFn(v, item) {
      v = v.toString().replace(/,/g,"")
      item.plan_amount = v
      this.countCost()
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    addPlan(arr) {
      arr.push({
        plan_name: '',
        plan_amount: '',
        hope_pay_time: '',
      });
      this.billNameFn()
    },
    removePlan(arr, index) {
      if (this.level != 1) {
        if (arr[index].pay_check_status == '3') {
          this.$message.error('支付审核之后不可删除')
          return false
        }        
      }
      this.del_plan_list.push(arr[index].id);
      console.log(this.del_plan_list);
      arr = arr.splice(index, 1);
      if (this.form.pay_type == '1') {
        this.countCost()
        this.billNameFn()
      }
    }, 
    billNameFn() {
      const len = this.form.planList.length
      if (this.form.pay_type == '1') {
        if (len == 1) {
          this.form.planList[0].plan_name = `全款`
        }
        else if (len == 2) {
          this.form.planList[0].plan_name = `第1期`
          this.form.planList[1].plan_name = `尾款`
        }
        else if (len > 2)  {
          for (let i = 0; i < this.form.planList.length; i++) {
            let item = this.form.planList[i];
            item.plan_name = `第${i+1}期`
            if (i == this.form.planList.length - 1) {
              item.plan_name = `尾款`
            }
          }
        }        
      }
    },
    countCost() {
      let nowCost = 0
      if (this.form.pay_type == '1') {
        for (let i = 0; i < this.form.planList.length; i++) {
          const element = Number(this.form.planList[i].plan_amount * 100);
          nowCost += element
        }
      }
      else {
        const plan_type = this.form.planList1[1].plan_type
        const plan_amount0 = Number(this.form.planList1[0].plan_amount * 100)
        const plan_amount1 = Number(this.form.planList1[1].plan_amount * 100)
        if (plan_type == '1') {
          nowCost = plan_amount0 - plan_amount1
        } else if (plan_type == '2' || plan_type == '3') {
          nowCost = plan_amount0 + plan_amount1
        }
      }
      this.nowCost = thousands(nowCost / 100)
      const remainContractAmount = this.form.vendorContractArr ? (Number(this.form.vendorContractArr.remainContractAmount) * 100 )/100 + ( this.planCost * 100)/100 : this.form.budget
      this.remainCost = thousands((Number(remainContractAmount) * 100 - nowCost) / 100)
    },
    changePlanType(v) {//结算切换正负号
      console.log(v);
      if (v == '3') {
        this.form.planList1[1].plan_amount = '0.00'
      }
      this.countCost()
    },           
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiProject_getPayDetail.html', {
          pay_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          if (form.pay_type == '1') {//正常
            form.planList = form.planList.map((item) => {
              item.hope_pay_time = timeFormat(item.hope_pay_time)
              return item
            })
            let planCost = 0
            form.planList.forEach((item) => {
              planCost += Number(item.plan_amount)
            })
            this.planCost = planCost.toFixed(2)
          }
          else if (form.pay_type == '2'){//预支
            if (form.planList.length > 0) {
              form.planList1 = form.planList.map((item, index) => {
                item.hope_pay_time = timeFormat(item.hope_pay_time)
                if (index == 1) {
                  if (item.plan_amount.indexOf("-") != -1 && item.plan_amount != '0.00') {//正且有值
                    item.plan_type = '1'//应退
                    item.plan_amount = item.plan_amount.split("-")[1]
                  } 
                  else if (item.plan_amount.indexOf("-") == -1 && item.plan_amount != '0.00') {//负且有值
                    item.plan_type = '2'//应补
                  } 
                  else if (item.plan_amount == '0.00') {
                    item.plan_type = '3'//无需退补
                  }
                }           
                return item
              })                            
            }
            else {
              form.planList1 = [
                { plan_name: '预支', plan_amount: form.budget, hope_pay_time: '', },
                { plan_name: '结算', plan_amount: '0.00', hope_pay_time: '', plan_type: '3' }
              ]
            }
            let planCost = 0
            const plan_type = form.planList1[1].plan_type
            const plan_amount0 = Number(form.planList1[0].plan_amount * 100)
            const plan_amount1 = Number(form.planList1[1].plan_amount * 100)
            if (plan_type == '1') {
              planCost = plan_amount0 - plan_amount1
            } else if (plan_type == '2' || plan_type == '3') {
              planCost = plan_amount0 + plan_amount1
            }
            this.planCost = planCost / 100             
          }
          this.fileList = form.fileList.filter(item => item.file_type == '1').map((item) => {
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况
          if (form.planList.length === 0) {
            form.planList = [{ plan_name: '', plan_amount: '', hope_pay_time: '', }]
          }
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          this.form = form
          this.billNameFn()
          this.countCost()
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.realName = store.state.realName
            console.log(this.level);
          }, 200);            
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdatePay()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdatePay() {
      if (this.form.pay_type == '1') {
        if (antiThousands(this.remainCost) < 0) {
          this.$message.error('成本不能大于预算及合同金额')
          return false
        }
      }
      if (this.form.pay_type == '1' && !this.form.planList[0].plan_amount) {
        this.$message.error('请完善至少一条支付计划')
        return false
      }
      if (this.form.pay_type == '2' && (!this.form.planList1[0].plan_amount || !this.form.planList1[0].hope_pay_time)) {
        this.$message.error('请完善预支计划')
        return false
      }
      if (this.form.pay_type == '2' && this.form.planList1) {
        if ((!this.form.planList1[1].plan_amount && this.form.planList1[1].hope_pay_time) || (!this.form.planList1[1].hope_pay_time && this.form.planList1[1].plan_amount != '0.00')) {
          this.$message.error('请完善结算计划')
          return false
        }
      }
      // 替换掉id为plan_id
      if (this.form.pay_type == '1') {
        const $planList = this.form.planList.map((item) => {
          Object.keys(item).forEach(key => {
            if (key == 'id') {
              item['plan_id'] = item[key]
              console.log(item['plan_id']);
              delete item[key]
            }
          })
          return item
        })
        this.form.planList = $planList
      }
      else {
        const $planList = this.form.planList1.map((item) => {
          Object.keys(item).forEach(key => {
            if (key == 'id') {
              item['plan_id'] = item[key]
              console.log(item['plan_id']);
              delete item[key]
            }
          })
          return item
        })
        $planList[1].plan_amount = $planList[1].plan_type == '1' ? '-' + $planList[1].plan_amount : $planList[1].plan_amount
        this.form.planList1 = $planList
      }      
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1 = this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList

      const tempForm = JSON.parse(JSON.stringify(this.form))
      const { id, son_project_id, contract_id, vendor_id } = tempForm
      this.$fly
        .post('apiProject_addUpdatePay.html', {
          pay_id: id, 
          son_project_id, 
          contract_id, 
          vendor_id,
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString(),
          plan_str: this.form.pay_type == 1 ? JSON.stringify(this.form.planList) : JSON.stringify(this.form.planList1),
          plan_del: this.form.pay_type == 1 ? this.del_plan_list.toString() : '',
          option: this.form.id ? '2' : '1',
          mType: this.mType,
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .bbtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }
        }
      }
    }

  }
}
</style>
